import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Tajiri from '../../../assets/images/TajiriAdmin.svg';

const AuthLayout = ({ children }) => {
  return (
    <div className="w-screen h-screen bg-[#E9FCF7] m-0 flex items-center flex-col">
      <div className="h-[90px] mt-4  w-[230px]">
        <img src={Tajiri} alt="" className="block h-full w-full  " />
      </div>
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </div>
  );
};

export default AuthLayout;
